<template>
    <div class="span12 pagination-centered">
        <div class="checkbox">
            <label>
                <input type="checkbox" v-model="filter.is_enabled_for_browser">Is Enabled For Browser
            </label>
        </div>
        <div class="checkbox">
            <label>
                <input type="checkbox" v-model="filter.is_enabled_for_server_to_server">Is enabled For Server To server
            </label>
        </div>
        <div class="checkbox">
            <label><input type="checkbox" v-model="filter.is_enabled_for_owned_websites">
                Is enabled for Owned Websites
            </label>
        </div>
        <div class="checkbox">
            <label>
                <input type="checkbox" v-model="filter.is_enabled_for_traffic_code_static">
                Is enabled for traffic code redirect
            </label>
        </div>
        <div class="checkbox">
            <label>
                <input type="checkbox" v-model="filter.is_enabled_for_traffic_code_redirect">
                Is enabled for traffic code static
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "PixelTargetFilter",
    data() {
        return {
            filter: {
                is_enabled_for_server_to_server: false,
                is_enabled_for_browser: false,
                is_enabled_for_owned_websites: false,
                is_enabled_for_traffic_code_redirect: false,
                is_enabled_for_traffic_code_static: false
            }
        }
    },
    watch: {
        filter: {
            handler(filter) {
                const data = {
                    pixel: JSON.parse(JSON.stringify(filter))
                };

                this.$emit('filtered', data);
            },
            deep: true
        },
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/widgets/InsightWidget/Filter/PixelTargetFilter.vue